import { ReactNode, useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from './CmnContext';

function Modal(props: any) {

  const isPc = useContext(cmnContext).isPc;

  const comp: ReactNode = props.comp;

  const isDispModal = props.isDispModal;
  const setIsDispModal = props.setIsDispModal;

  const isDispClose = props.isDispClose
    ? props.isDispClose : false;
  const isBackClose = props.isBackClose !== undefined
    ? props.isBackClose : true;
  const modalWidth = props.modalWidth
    ? props.modalWidth
    : isPc? '40%' : '90%';
  const modalHeight = props.modalHeight
    ? props.modalMaxHeight
    : 'auto';
  const modalMaxHeight = props.modalMaxHeight
    ? props.modalMaxHeight
    : '80vh';


  // モーダル表示時に背景スクロールを止める
  useEffect(() => {
    if (isDispModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // アンマウント時にも戻す（安全のため）
    return () => {
      document.body.style.overflow = '';
    };
  }, [isDispModal]);


  return (
    <>
    {isDispModal &&
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1040, //SPフッターが1030
        }}
        onClick={() => {
          if(isBackClose) {
            setIsDispModal(false);
          }
        }}
      >

        <div
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: modalWidth,
            backgroundColor: 'transparent',
            borderRadius: '8px',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* 閉じるボタン */}
          {isDispClose &&
            <button
              type="button"
              onClick={() => setIsDispModal(false)}
              style={{
                position: 'absolute',
                top: isPc? '-50px' : '-45px',
                right: isPc? '5px' : '0',
                background: 'none',
                border: 'none',
                fontSize: isPc? '40px' : '35px',
                fontWeight: 'bold',
                color: '#fff',
              }}
            >×</button>
          }

          {/* モーダルの中 */}
          <div
            style={{
              height: modalHeight,
              maxHeight: modalMaxHeight,
              overflowY: 'auto',
            }}
          >
            {comp}
            {/* スマホで表示した際に最下部までスクロールできないことがある */}
            {!isPc &&
              <div style={{height: '10vh', backgroundColor: 'transparent'}}></div>
            }
          </div>

        </div>
      </div>
    }
    </>
  );
}
  
export default Modal;